export { default } from './Impressum';



// WEBPACK FOOTER //
// ./src/components/Impressum/index.js